<template>
  <DialogTemplateToolkit
    :data-qa="'new-release-dialog'"
    :dialog="dialog"
    first_btn="Common.ThankYou"
    second_action
    second_btn="Releases.AllChanges"
    :title="$t('Releases.LastUpdates')"
    @action="toAll"
    @close="close">
    <template #card-text>
      <div
        v-for="(value, name, typeItemIndex) in release.releaseFormat"
        :key="`type-${typeItemIndex}`"
        class="feature__card">
        <div
          class="feature__card-head">
          <div class="feature__card-head-title">
            {{ $t('Releases.groupTitle.' + name) }}
          </div>
          <div class="feature__card-head-badge">
            {{ value.length }}
          </div>
        </div>
        <div class="feature__card-features">
          <div
            v-for="(featureItem, featureItemIndex) in value"
            :key="`feature-${typeItemIndex}-${featureItemIndex}`"
            class="feature__card-features-item">
            <div class="feature__card-features-item-title">
              <div class="feature__card-features-item-title-text">
                {{ english_lang ? featureItem.nameEng : featureItem.name }}
              </div>
              <sButton
                v-if="english_lang ? featureItem.linkEng : featureItem.link"
                :href=" (english_lang ? featureItem.linkEng : featureItem.link) || '/futures#' + item.id "
                small
                :target="( english_lang ? featureItem.linkEng : featureItem.link ) ? '_blank' : '_self'"
                type="text">
                {{ $t('Tenders.ReadMore') }}
              </sButton>
            </div>
            <div class="feature__card-features-item-subtitle">
              {{ english_lang ? featureItem.descriptionEng : featureItem.description }}
            </div>
          </div>
        </div>
      </div>
    </template>
    <template #card-actions>
      <div
        class="flex flex-between">
        <sButton
          data-qa="btn-dialog-template-first"
          @action="$emit('apply')"
          @click="submit">
          {{ $t('Common.ThankYou') }}
        </sButton>
        <sCheckbox
          v-model="do_not_notify"
          class="my-auto"
          data-qa="cb-doNotNotifyOfUpdates"
          @input="changeReleaseNotificationOption">
          {{ $t('Releases.DoNotNotifyOfUpdates') }}
        </sCheckbox>
      </div>
    </template>
  </DialogTemplateToolkit>
</template>
<script>
import DialogTemplateToolkit from 'components/common/dialogs/DialogTemplateToolkit.vue'

import { mapGetters } from 'vuex'

export default {
  name: 'newReleaseDialog',
  data() {
    return {
      dialog: false,
      do_not_notify: false,
      release: {}
    }
  },
  methods: {
    onShowNewRelease() {
      this.dialog = true
      this.release = this.releaseSettings || {}
      const releaseFormat = {}
      this.releaseSettings.features.map(i => {
        if (releaseFormat[i.type]) {
          releaseFormat[i.type].push(i)
        } else {
          releaseFormat[i.type] = [i]
        }
      })

      const fieldName = this.english_lang ? 'nameEng' : 'name'
      Object.values(releaseFormat).forEach((items) => {
        items.sort((a,b) => a[fieldName]?.localeCompare(b[fieldName]))
      })

      this.$set(this.release, 'releaseFormat', releaseFormat)
      this.do_not_notify = this.releaseSettings?.dontNotify
    },
    submit() {
      this.close()
    },
    close() {
      this.$store.dispatch('setSignLastSeenRelease')
      this.dialog = false
    },
    toAll() {
      this.$router.push({name: 'releases'})
      this.close()
    },
    changeReleaseNotificationOption() {
      this.$store.dispatch('changeReleaseNotificationOption', !this.do_not_notify)
    }
  },
  computed: {
    ...mapGetters({
      releases: 'getReleases',
    }),
    english_lang() {
      return this.$i18n.locale == 'en'
    },
  },
  props: {
    releaseSettings: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    DialogTemplateToolkit
  },
  mounted() {
    this.onShowNewRelease()
  },
}
</script>
<style lang="scss" scoped>
.feature__card {
  border-bottom: 1px solid var(--v-secondary__green_chosen-base);
  &-head {
    display: flex;
    background: var(--v-secondary__green_chosen-base);
    font-weight: 600;
    margin-bottom: 10px;
    padding: 5px 5px;
    border-radius: 2px;
    &-text {
      font-weight: 500;
      font-size: 17px;
      line-height: 24px;
      letter-spacing: 0.01em;
    }
    &-badge {
      border: 1px solid var(--black-color);
      display: initial;
      line-height: 14px;
      font-size: 12px;
      border-radius: 15px;
      padding: 0 7px;
      color: var(--white-color);
      background: var(--black-color);
      font-weight: 400;
      height: 16px;
      margin: auto 0 auto 10px;
    }
  }
  &-features {
    &-item {
      display: flex;
      flex-wrap: wrap;
      counter-increment: line;
      margin-bottom: 10px;
      &-title {
        display: flex;
        flex: 1 1 auto;
        justify-content: space-between;
      }
      &-subtitle {
        width: 100%;
        font-size: 14px;
        line-height: 18px;
        opacity: 0.8;
        padding-left: 15px;
        text-align: justify;
      }
      &:before {
        content: counter(line);
        display: inline-block;
        padding: 0 5px 0 0;
      }
    }
  }
}
</style>
